<template>
  <WalkthroughTour />
  <OnboardingModal />
  <UpdateNotification />
  <RouterView :key="route.path" />
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import WalkthroughTour from './components/global/WalkthroughTour.vue';
import OnboardingModal from './components/global/OnboardingModal.vue';
import UpdateNotification from './components/global/UpdateNotification.vue';
import { onMounted, onUnmounted } from 'vue';
import { useUserStore } from './stores/user';
import router from '@/router/index';
const route = useRoute();

const visibilityHandler = async () => {
  if (!document.hidden) {
    const userStore = useUserStore()
    if (userStore.isLoggedIn) {
      const result = await userStore.checkTokenExpiry();
      if (result !== true) {
        router.push(result.toString());
      }
    }
  }
};

onMounted(() => {
  document.addEventListener('visibilitychange', visibilityHandler)
});

onUnmounted(() => {
  document.removeEventListener('visibilitychange', visibilityHandler)
});

</script>
